/*
The screen.orientation.type can return the following values:
landscape-primary: The screen is in primary landscape mode (horizontal, with the right side up).
landscape-secondary: The screen is in secondary landscape mode (horizontal, with the left side up)
portrait-primary: The screen is in primary portrait mode (vertical, with the top side up).
portrait-secondary: The screen is in secondary portrait mode (upside down).
 */

import { trace } from "owa-trace";

export function getScreenOrientation(): ScreenOrientation["type"] {
    try {
        // Check if the Screen Orientation API is supported
        if (window.screen.orientation?.type) {
            return screen.orientation.type;
        }
        else {
            // Fallback for browsers that do not support the Screen Orientation API
            // Use matchMedia to determine orientation
            if (window.matchMedia("(orientation: portrait)").matches) {
                return "portrait-primary";
            }
            else if (window.matchMedia("(orientation: landscape)").matches) {
                return "landscape-primary";
            }
        }
    }
    catch (e) {
        // Catch any errors and default to landscape-primary
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS18046: 'e' is of type 'unknown'.
        // @ts-expect-error
        trace.warn("GetScreenOrientationError: " + e.toString());
    }
    // Default to landscape-primary if we can't determine orientation
    return "landscape-primary";
}
